'use client'

// Allows inline scripts to execute
import InnerHTML from 'dangerously-set-html-content'

export default function ParseHtmlClient({ html }: { html: string }): JSX.Element | null {
  return <InnerHTML html={html} />
}
